<template>
    <div class="content-main no-padding-right no-padding-left   col-md-12 col-sm-12 col-xs-12">
        <div class="row">
            <div class="page-title div-img-header">
                <div class="container">
                    <div class="row">
                        <div class="div-title-main col col-xs-12">
                            <h2>About Us</h2>
                            <ol class="breadcrumb">
                                <li><router-link to="/">Home</router-link></li>
                                <li>About Us</li>
                            </ol>
                        </div>
                    </div> <!-- end row -->
                </div>
            </div>
            <nav class="main-menu">
                <div class="">
                    <ul data-v-1e58fd16="" class="list float-right">
                        <li data-v-1e58fd16="" class="list-item list-item-has-children mega-menu mega-menu-col-5">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li data-v-1e58fd16="" class="list-item list-item-has-children mega-menu mega-menu-col-5">
                            <router-link to="/aboutUs">About Us</router-link>
                        </li>
                        <li data-v-1e58fd16="" class="list-item list-item-has-children mega-menu mega-menu-col-5">
                            <router-link to="/contactUs">Contact Us </router-link>
                        </li>
                        <li data-v-1e58fd16="" class="list-item list-item-has-children mega-menu mega-menu-col-5">
                            <router-link to="/verification">Check</router-link>
                        </li>
                    </ul>
                </div>
            </nav>
            <div class="content">
                <div class="div-content pb-20">
                    <div class="row">
                        <div class="section-about col-xs-12 col-lg-5 col-md-12">
                            <h1>NORSLAB</h1>
                            <p>
                                We are one of the largest laboratories in the European Union, which was established in Bulgaria and in the city of Sofia. We specialize in the production of drugs and we produce drugs of very high quality, as well as raw materials for the manufacture of drugs for several large pharmaceutical companies. We also provide, we have 654 active personnel.
                            </p>
                        </div>
                        <div class="pt-60 col-lg-7 col-xs-12">
                            <div class="offer-pic">
                                <img src="/assets/img/inline-page/offer-pic.jpg" alt="ABP PHARMACEUTICALS" style="float: right;" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        beforeMount: function () {
            createPageTitle('AboutUs');
        }
    }
</script>

<style scoped>
   

    .div-img-header {
        background: url("/assets/img/header/AboutUs.jpg");
        background-size: cover;
        min-height: 550px;
        background-repeat: no-repeat;
        position: relative;
        width: 100%;
    }
        .div-img-header .row{
            background-color: transparent !important;
        }
        .page-title .breadcrumb {
            text-align: center;
        }

    .page-title .breadcrumb {
        background-color: transparent;
        padding: 0;
    }

    .page-title ol {
        color: #fff;
    }

    .page-title h2 {
        font-size: 48px;
        font-size: 3.2rem;
        font-weight: 800;
        margin: 0.23em 0 0.23em;
    }

    .page-title h2 {
        color: #fff;
    }

    .page-title .breadcrumb li a {
        color: #fff;
    }

    .page-title .breadcrumb li {
        font-size: 18px;
        font-size: 1.2rem;
        color: #fff;
        font-weight: bold;
        margin-right: 5px;
    }
    .page-title .breadcrumb > li + li::before {
        font-family: "FontAwesome";
        content: "\f105";
        color: #fff;
        margin-right: 5px;
    }


    .section-about h1 {
        font-size: 30px;
    }

    .page-title .breadcrumb li a:hover {
        color: #FFD700;
    }

   
   

    .hr {
        margin-top: 45px;
        margin-bottom: 30px;
    }
    /*محتویات Css  قسمت مدیریت صفحات استاتیک*/

    .content-main .content {
        width: 100%;
        margin: 10px 0%;
        padding: 80px;
    }

        .content-main .content .title {
            font-size: 20px;
            padding-left: 20px;
            padding-top: 20px;
        }

        .content-main .content .div-content p {
       
            line-height: 2;
            font-size: 15px;
        }
    /***ooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooo*/
    .box-tabs-tab a {
        padding: 14px 20px;
        position: relative;
        color: #6f6f6f;
        display: block;
        line-height: 27px;
        height: 100%;
        width: 100%;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .none-border::after {
        border-bottom: unset !important;
    }

    .box-tabs-tab {
        border-right: unset;
        position: relative;
        margin-right: 50px;
        margin-left: 50px;
    }

    .box-tabs > ul {
        list-style: none;
        border: unset;
        background-color: unset;
        font-size: 17px;
        font-size: 1.214rem;
        line-height: 1.294;
        letter-spacing: -.4px;
        width: 100%;
        padding: 0;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }

   

    .box-tabs-tab a {
        border: 1px solid #0a548b;
    }

        .box-tabs-tab a.active {
            background-color: #0a548b;
            color: #fff;
            border: 1px solid #0a548b;
            margin-left: -1px;
        }

    .param-p {
     
        line-height: 2;
    }
    .div-title-main {
        padding-left: 80px;
        margin-top: 155px;
        background: rgba(0,0,0,.5);
    }
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .div-img-header {
            min-height: unset !important;
        }
        .content-main .content {
            width: 100%;
            padding: 20px;
        }
    .box-tabs > ul {
            padding-left: 20px;
        }

    .section-about h1 {
            font-size: 19px;
            font-weight: bold;
        }

    .div-title-main {
            padding-left: 20px;
            margin-top: 155px;
        }

    .param-title span, .param-title {
            font-size: 14px;
        }

    .param-p {
            font-size: 12px;
        }

  

    .content-main .content .title {
                font-size: 17px;
            }

    .content-main .content .div-content p {
                line-height: 2;
                font-size: 14px;
            }

    

    .address-title span {
            font-size: 16px;
        }

   

    .content-main .content .title {
                font-size: 17px;
            }
    .content-main .content .div-content p {
                text-align: justify;
                line-height: 2;
                font-size: 12px;
            }
    }
    /*محتویات Css  قسمت مدیریت صفحات استاتیک*/
    .main-menu {
        width: 100%;
        float: left;
        background: #fff;
        margin-top: 5px;
        min-height: 50px;
        margin-bottom: 20px;
    }

        .main-menu .list {
            width: 100%;
            margin-bottom: 0;
            padding-left: 0;
            position: relative;
            list-style: none;
            text-align: center;
            background-color: #0687e6;
        }

            .main-menu .list .list-item {
                display: inline-block;
                padding: 5px;
                margin: 10px;
                border-radius: 5px;
                box-shadow: 1px 1px 1px 0px rgb(0, 0, 0);
                min-width: 130px;
                background-color: #fff;
            }

            .main-menu .list > .list-item > a,
            .main-menu .list > .list-item > span {
                color: #235ea3;
                padding: 8px 18px 8px 18px;
                border-top: 2px solid transparent;
                border-bottom: 2px solid transparent;
                position: relative;
                font-size: 16px;
                font-weight: bold;
                display: inline-block;
            }
</style>